export default "__VITE_ASSET__CCKTNRg4__"